import React from 'react'
import './Message.css'
import { MdAccountCircle } from 'react-icons/md'

function Message({ timestamp, message, user }) {
  return (
    <div className='message'>
        <div className='message__info'>
          { user.photo ? <img src={user.photo} alt="User Photo" /> : <MdAccountCircle className='icon' />} 
          <h4>{user.displayName}</h4>
          <span className="message__timestamp">
            {new Date(timestamp?.toDate()).toUTCString()}
          </span>
        </div>
        <div className='message__message'>
          <p>{message}</p>
        </div>
    </div>
  )
}

export default Message